import { render, staticRenderFns } from "./MobileOrder.vue?vue&type=template&id=6bf67c70&"
import script from "./MobileOrder.vue?vue&type=script&lang=js&"
export * from "./MobileOrder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports